import React from "react";
import { Box } from "@mui/material";
import DeviceComponent from "../component/device-components/DeviceComponent";

const DevicePage = () => {
  return (
    <Box>
      <DeviceComponent />
    </Box>
  );
};

export default DevicePage;
